<template>
    <div class="d-flex flex-wrap flex-column">
        <p>
            <small>comentário: <span v-html="item.data.model.comentario"></span></small>
        </p>
        <div class="d-flex justify-content-between" style="width:100%">
            <b-button :variant="conditionResponder()" v-if="!item.read_at" @click.prevent="show_form = !show_form"><small
                    v-if="!show_form">Responder</small><small v-else>Cancelar resposta</small>
            </b-button>

            <div class="d-flex justify-content-between align-items-center">

                <small v-if="item.read_at"><i class="fas fa-check"></i> Tarefa visualizada
                    {{ moment(item.read_at).format("LLLL") }}
                </small>
                <b-button variant="link" @click.prevent="verTarefa()"><small>Ver tarefa</small></b-button>
            </div>
        </div>


        <div class="form-group" v-if="show_form">
            <label><small>Responder:</small></label>

            <Comentario class="comentario" :tarefa_id="item.data.model.tarefa.tarefa_id" :reply_id="item.data.model.id"
                :notification_id="item.id" @afterSave="show_form = false"></Comentario>
        </div>


    </div>
</template>
<script>
import Comentario from "../../tarefas/forms/Comentario.vue";
export default {
    components: { Comentario },
    props: {
        item: Object
    },
    data() {
        return {
            show_form: false,
            comentario: null,
        };
    },
    methods: {
        verTarefa() {
            this.$root.$emit('verTarefa', this.item);
        },
        conditionResponder() {
            return 'link ' + ((this.show_form) ? 'text-danger' : '');
        },
        // submit() {
        //     this.$api.post('tarefa/addComentario', {
        //         action_id: 20,
        //         reply_id: this.item.data.model.id,
        //         comentario: this.comentario,
        //         reply_user_id: this.item.data.user_id,
        //         tarefa_id: this.item.data.model.tarefa.tarefa_id,
        //         notification_id: this.notification_id,
        //         reply_id: this.reply_id,
        //         colaboradores: [{ id: parseInt(this.item.data.user_id) }]
        //     }).then(() => {
        //         this.$emit('read');
        //     });

        // },
    }
}
</script>
<style scoped>
  .comentario::v-deep .atwho-panel {
    position: relative !important;
    left: 0px !important;
    top: 0px !important;
  }
</style>
